<c-widget-stat-b
    [title]="title"
    class="no-border"
    [text]="subTitle"
    [value]="valuePercent"
    >
    <c-progress class="my-2" thin [value]="value()" color="success" />
</c-widget-stat-b>
